import React from 'react';
import { Card, Empty, Tag } from 'antd';
import Chart from 'react-apexcharts';
import { HddOutlined } from '@ant-design/icons';

const DiskIOChart = ({ servidor, height = 300 }) => {
  if (!servidor?.datos?.length) {
    return <Card title={servidor?.nombre || 'Sin datos'}><Empty description="No hay datos de I/O de disco disponibles" /></Card>;
  }

  const labels = servidor.datos.map(d => new Date(d.timestamp).getTime());
  const lecturaData = servidor.datos.map(d => d.lectura);
  const escrituraData = servidor.datos.map(d => d.escritura);

  const lecturaPromedio = (lecturaData.reduce((a, b) => a + b, 0) / lecturaData.length).toFixed(2);
  const escrituraPromedio = (escrituraData.reduce((a, b) => a + b, 0) / escrituraData.length).toFixed(2);
  const lecturaMax = Math.max(...lecturaData).toFixed(2);
  const escrituraMax = Math.max(...escrituraData).toFixed(2);

  return (
    <Card
      title={
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 8 }}>
          <span><HddOutlined style={{ marginRight: 8 }} />{servidor.nombre}{servidor.ip && <span style={{ fontSize: 12, color: '#888', marginLeft: 8 }}>({servidor.ip})</span>}</span>
          <span style={{ fontSize: 12, fontWeight: 'normal' }}>
            <Tag color="blue">Lectura avg: {lecturaPromedio} KB/s (max: {lecturaMax})</Tag>
            <Tag color="green">Escritura avg: {escrituraPromedio} KB/s (max: {escrituraMax})</Tag>
          </span>
        </div>
      }
      style={{ marginBottom: 16 }}
    >
      <Chart
        type="area"
        height={height}
        options={{
          chart: { toolbar: { show: false }, zoom: { enabled: true } },
          stroke: { width: 2, curve: 'smooth' },
          colors: ['#3b82f6', '#10b759'],
          fill: { type: 'gradient', gradient: { opacityFrom: 0.25, opacityTo: 0.05 } },
          xaxis: { type: 'datetime', categories: labels, labels: { datetimeFormatter: { hour: 'HH:mm', day: 'dd/MM' } } },
          yaxis: { title: { text: 'Velocidad (KB/s)' }, min: 0 },
          grid: { borderColor: '#e5e9f2', strokeDashArray: 3 },
          tooltip: { x: { format: 'dd/MM HH:mm' }, y: { formatter: v => `${v.toFixed(2)} KB/s` } },
          legend: { position: 'top' },
          dataLabels: { enabled: false },
        }}
        series={[
          { name: 'Lectura', data: lecturaData },
          { name: 'Escritura', data: escrituraData },
        ]}
      />
    </Card>
  );
};

export default DiskIOChart;
